var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    color: "#fff",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M17.364 6v8.182c0 .903-.733 1.636-1.637 1.636H4.273a1.636 1.636 0 0 1-1.637-1.636V6m14.728 0c0-.904-.733-1.636-1.637-1.636H4.273c-.904 0-1.637.732-1.637 1.636m14.728 0L10 10.909l-7.364-4.91"
  })));
};
export default SvgMail;